// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"30136ea3","540":"6153065f","541":"3e2deacc","611":"e2ead287"}[chunkId] + ".chunk.js";
};